/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { BiHomeAlt } from "react-icons/bi";
import {
  BusinessSVG,
  AlertSVG,
  TasksSVG,
  AdaptersSVG,
  LogAndEventManagement,
  OpenSearch,
} from "../assets/svg";
const OPENSEARCH_URL = process.env.REACT_APP_OPENSEARCH;

interface UrlLink {
  id: string;
  label?: string;
  url?: string;
  isSubLinks?: boolean;
  sublinks?: Array<UrlLink>;
  shouldOpenNewTab?: boolean;
}

export interface NavLink extends UrlLink {
  icon?: React.ReactNode;
  navigate?: () => void;
}

const PROCESS_INSTANCES = "process-instances";

const _dashboardLinks: Array<NavLink> = [
  {
    id: "$home",
    icon: <BiHomeAlt size={25} />,
    label: "Home",
    url: "/dashboard",
  },
  {
    id: "$aim",
    icon: <BusinessSVG />,
    label: "Advanced Integration Manager",
    isSubLinks: true,
    sublinks: [
      {
        id: "$process-integrator",
        label: "Process Integrator",
        isSubLinks: true,
        sublinks: [
          {
            id: "$process-definitions",
            label: "Processes",
            url: "/process-definitions",
          },
          {
            id: "$" + PROCESS_INSTANCES,
            label: "Process Instance",
            url: "/" + PROCESS_INSTANCES,
          },
          {
            id: "$process-templates",
            label: "Process Templates",
            url: "/process-templates",
          },
          {
            id: "$credential-manager",
            label: "Credential Manager",
            url: "/credential-manager",
          },
        ],
      },
      {
        id: "$api-integrator",
        label: "API Integrator",
        url: "/api-integrator",
      },
    ],
  },
  {
    id: "$tasks",
    icon: <TasksSVG />,
    label: "Tasks",
    isSubLinks: true,
    sublinks: [{ id: "$view-tasks", label: "View Tasks", url: "/view-tasks" }],
  },
  {
    id: "$ot",
    icon: <TasksSVG />,
    label: "OT Assets",
    url: "/ot-assests",
  },
  {
    id: "$adapt",
    icon: <AdaptersSVG />,
    label: "Adapters",
    isSubLinks: true,
    sublinks: [
      {
        id: "$configure-adapters",
        label: "Configure Adapters",
        url: "/configure-adapters",
      },
      { id: "$view-adapters", label: "View Adapters", url: "/view-adapters" },
    ],
  },
  {
    id: "$alert",
    icon: <AlertSVG />,
    label: "Alerts",
    isSubLinks: true,
    sublinks: [
      { id: "$manage-alerts", label: "Manage Alerts", url: "/manage-alerts" },
      { id: "$view-alerts", label: "View Alerts", url: "/view-alerts" },
    ],
  },
  {
    id: "$logAndEventManagement",
    icon: <LogAndEventManagement />,
    label: "Log and Event Management",
    isSubLinks: true,
    sublinks: [
      // {
      //   id: "$view-instace-logs",
      //   label: "View Instance Logs",
      //   url: OPENSEARCH_URL,
      //   shouldOpenNewTab: true,
      // },
      {
        id: "$view-system-logs",
        label: "View System Logs",
        url: "system-logs",
        // shouldOpenNewTab: true,
      },
    ],
  },
];

const _workflowLinks = (
  navigateTo: (to: string, options: any) => void
): Array<NavLink> => [
  {
    id: "$process-definitions",
    label: "Process definitons",
    url: "/process-definitions",
  },
  {
    id: "$process-instances",
    icon: "",
    label: "Process instance",
    url: "/process-instances",
  },
  {
    id: "$wf-response",
    icon: "",
    label: "Search response",
    url: "/workflow-registry",
  },
];

const _dashboardRouteMapper = {
  "/3insys/dashboard": "$home",
};

const _workflowRouteMapper = {
  "/workflow-definitions": "$wf-definitions",
  "/process-instances": "$process-instances",
  "/workflow-registry": "$wf-response",
};

export default {
  _dashboardLinks,
  _workflowLinks,
  _dashboardRouteMapper,
  _workflowRouteMapper,
};
